module.exports = __webpack_public_path__ + "static/media/effect_07.a05e05f5.png";